import { useMediaQuery as useResponsiveMediaQuery } from "react-responsive";

import { GRID_BREAKPOINTS } from "@constants/global.constants";

type BreakpointType = number | keyof typeof GRID_BREAKPOINTS;

type Props = {
  minWidth?: BreakpointType | number;
  maxWidth?: BreakpointType | number;
};

const getBreakpoint = (breakpoint?: BreakpointType) => {
  if (breakpoint && typeof breakpoint !== "number") {
    return GRID_BREAKPOINTS[breakpoint];
  }
  return breakpoint;
};

export function useMediaQuery({ minWidth, maxWidth }: Props) {
  return useResponsiveMediaQuery({
    minWidth: getBreakpoint(minWidth),
    maxWidth: getBreakpoint(maxWidth),
  });
}
